export default __webpack_public_path__ + "locales/en/Notifications.json?hash=e1f0f7b1643c3fbf1e7686af2fb73dc9";